import { Component } from '@angular/core';
import {NgForOf, NgIf} from '@angular/common';
import {ChatSection} from '../../../model/chat';
import {FormsModule} from '@angular/forms';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-chat-page',
  imports: [
    NgIf,
    NgForOf,
    FormsModule
  ],
  templateUrl: './chat-page.component.html',
  styleUrl: './chat-page.component.scss'
})
export class ChatPageComponent {

  constructor(public languageService: LanguageService) {}

  chatOnlineStatus: 'Online' | 'Offline' = 'Offline';
  chatSections: ChatSection[] = [
    {
      date: 'Today, April 24',
      messages: [
        {
          user: 'Meet+Greet Assist',
          message: 'Good afternoon! Thank you for reaching out to our company for booking services. How can I assist you today?',
          time: '10:30 AM',
          isImage: false
        }
      ]
    }
  ];
  tapping: boolean = false;
  newMessageText: string = '';
  selectedImage: string | null = null;
  selectedFileName: string = '';
  showModal: boolean = false;
  modalImageUrl: string = '';
  imagePreviewText: string = ''; // Отдельное поле для отображения имени файла

  get onlineStatus() {
    return this.chatOnlineStatus;
  }

  formatTime(): string {
    const now = new Date();
    let hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const minutesStr = minutes < 10 ? '0' + minutes : minutes.toString();
    return `${hours}:${minutesStr} ${ampm}`;
  }

  onSendMessage() {
    // Отправляем только если есть фото ИЛИ текст (но не оба сразу если это имя файла)
    const hasTextToSend = this.newMessageText.trim() && this.newMessageText !== this.imagePreviewText;

    if (!this.selectedImage && !hasTextToSend) {
      return;
    }

    const currentTime = this.formatTime();
    const lastSection = this.chatSections[this.chatSections.length - 1];

    // Отправляем фото если есть
    if (this.selectedImage) {
      lastSection.messages.push({
        user: 'You',
        message: this.selectedImage,
        time: currentTime,
        isImage: true,
        fileName: this.selectedFileName
      });
    }

    // Отправляем текст только если это реальный текст, а не имя файла
    if (hasTextToSend) {
      lastSection.messages.push({
        user: 'You',
        message: this.newMessageText,
        time: currentTime,
        isImage: false
      });
    }

    // Очищаем инпут и буфер
    this.newMessageText = '';
    this.selectedImage = null;
    this.selectedFileName = '';
    this.imagePreviewText = '';

    // Меняем статус на Online и запускаем печать бота
    this.chatOnlineStatus = 'Online';
    this.tapping = true;

    // Симулируем печать бота и ответ через 5 секунд
    setTimeout(() => {
      this.tapping = false;
      const botResponseTime = this.formatTime();
      lastSection.messages.push({
        user: 'Meet+Greet Assist',
        message: 'Great, thank you for contacting us! We offer a wide range of services, including airport transfers, VIP meet-and-greet services, escort services, and organizing tours around the city and its surroundings. Do you have any specific requirements?',
        time: botResponseTime,
        isImage: false
      });

      // Авто-скролл вниз
      setTimeout(() => this.scrollToBottom(), 100);
    }, 5000);

    // Авто-скролл вниз
    setTimeout(() => this.scrollToBottom(), 100);
  }

  onImageSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      this.selectedFileName = file.name;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.selectedImage = e.target?.result as string;
        // Показываем имя файла в инпуте как превью, но запоминаем что это превью
        this.imagePreviewText = file.name;
        this.newMessageText = file.name;
      };
      reader.readAsDataURL(file);
    }
  }

  onInputChange() {
    // Если пользователь удалил хотя бы один символ - очищаем всё
    if (this.selectedImage && this.newMessageText.length < this.imagePreviewText.length) {
      this.clearImageBuffer();
    } else if (this.selectedImage && this.newMessageText !== this.imagePreviewText) {
      // Если пользователь начал редактировать текст поверх имени файла
      // тоже очищаем буфер с фото
      this.clearImageBuffer();
    }
  }

  clearImageBuffer() {
    this.selectedImage = null;
    this.selectedFileName = '';
    this.imagePreviewText = '';
    // Но не очищаем newMessageText полностью, так как пользователь мог что-то ввести
    if (this.newMessageText === this.imagePreviewText) {
      this.newMessageText = '';
    }
  }

  triggerImageUpload() {
    const fileInput = document.getElementById('imageUpload') as HTMLInputElement;
    fileInput.click();
  }

  openModal(imageUrl: string) {
    this.modalImageUrl = imageUrl;
    this.showModal = true;
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.showModal = false;
    this.modalImageUrl = '';
    document.body.style.overflow = '';
  }

  scrollToBottom() {
    const chatContainer = document.querySelector('.chat-page-container-workspace-chat');
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  }


}
